import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AssetPageDataService } from '../../gallery/services/asset-page-data.service';
import { getAllRouteData } from '../../lib/get-all-route-data';
import { GalleryService } from '../../services/gallery.service';

export const publicAssetPageTitleResolver: ResolveFn<string> = async route => {
  const galleryService = inject(GalleryService);
  const assetPageDataService = inject(AssetPageDataService);
  const data = getAllRouteData(route);

  const gallery = await galleryService.getPublicGalleryFromSnapshot(route, { isPublic: true });
  const assetId = route.params.assetId.replace('}', '');
  const resp = await firstValueFrom(assetPageDataService.get(gallery, assetId, route.queryParams));

  if (!resp?.asset) return;
  return data.title + ` · ${resp.asset.version_data.asset_name}`;
};
